import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconTaboola = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <g clipPath={`url(#&{svgId})`}>
          <path
            d="M6.76152 6.65916C5.76676 6.65297 5.62818 7.62059 5.6239 8.34916C5.61961 9.07773 5.74676 10.0611 6.74104 10.0668C7.73533 10.0725 7.87438 9.09249 7.87866 8.36249C7.88295 7.63249 7.7558 6.6644 6.76152 6.65916ZM6.73152 11.9758C4.14533 11.9611 2.98819 10.2434 3.00009 8.33392C3.012 6.42439 4.18723 4.73439 6.77342 4.75011C9.35961 4.76582 10.5163 6.4682 10.5049 8.37773C10.4934 10.2873 9.31628 11.9911 6.73152 11.9758Z"
            fill="#0071B7"
          />
          <path
            d="M13.2776 6.65916C12.2833 6.65344 12.1452 7.62059 12.141 8.35011C12.1367 9.07963 12.2633 10.0611 13.2581 10.0673C14.2529 10.0734 14.3905 9.09249 14.3948 8.36297C14.399 7.63344 14.2719 6.66439 13.2776 6.65916ZM13.2467 11.9768C10.6614 11.9611 9.50428 10.2434 9.51571 8.33439C9.52714 6.42535 10.7033 4.73439 13.2886 4.75011C15.8738 4.76582 17.0314 6.46916 17.0205 8.3782C17.0095 10.2873 15.8324 11.9911 13.2467 11.9768Z"
            fill="#0071B7"
          />
          <path
            d="M3.98203 11.9775C5.84584 12.8104 7.78061 13.1804 9.8868 13.1923C12.1006 13.2052 13.7797 12.7871 15.9054 11.9775L15.893 14.2713C13.9882 15.2147 11.9277 15.7237 9.87156 15.7118C7.63346 15.6985 6.01442 15.2385 3.9668 14.2713L3.98203 11.9775Z"
            fill="#0071B7"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="14"
              height="14"
              transform="translate(3 3)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
